import { appendRecommendations, setRecommendationsPaginationStatus } from '../../actions/recommendations';
import { fetchRecommendationsPage } from '../../services/recommendations';
import { TThunkAction } from '../../types/redux';
import { EPaginationStatus } from '../../types/redux/recommendations';

function getFiniteNumber(value: number | undefined): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

export function fetchMoreRecommendations(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      recommendations: { geoRegionId, hasMore, page, paginationStatus, recommendations, totalCount },
    } = getState();

    if (!hasMore || paginationStatus === EPaginationStatus.Loading) {
      return;
    }

    const { anonymousUserId, hash, realtyUserId } = context.custom;
    const nextPage = page + 1;
    const requestGeoRegionId = geoRegionId || recommendations[0]?.geo.regionId;
    const requestRealtyUserId = getFiniteNumber(realtyUserId);

    dispatch(setRecommendationsPaginationStatus(EPaginationStatus.Loading));

    try {
      const result = await fetchRecommendationsPage(context, {
        anonymousUserId,
        ...(requestGeoRegionId ? { geoRegionId: requestGeoRegionId } : null),
        ...(hash ? { offersHash: hash } : null),
        page: nextPage,
        ...(requestRealtyUserId ? { realtyUserId: requestRealtyUserId } : null),
      });
      const nextTotalCount = result.totalCount ?? totalCount;
      const loadedRecommendationsCount = recommendations.length + result.recommendations.length;
      const hasLoadedRecommendations = result.recommendations.length > 0;
      const normalizedHasMore =
        hasLoadedRecommendations &&
        (result.hasMore || Boolean(nextTotalCount !== null && loadedRecommendationsCount < nextTotalCount));

      dispatch(
        appendRecommendations({
          ...result,
          hasMore: normalizedHasMore,
          totalCount: nextTotalCount,
        }),
      );
    } catch {
      dispatch(setRecommendationsPaginationStatus(EPaginationStatus.Error));
    }
  };
}
